import PropTypes from 'prop-types';

export default {
  isThirdPartyReservation: PropTypes.bool,
  thirdPartyReservationSupportNumber: PropTypes.string,
  isTourReservation: PropTypes.bool,
};
